import { WebAppShell } from './app/WebAppShell'
// EU-сервис: только web-режим. Telegram-shell сохранён закомментированным.
// import { ENV } from '@shared/config/env'
// import { TgAppShell } from './app/TgAppShell'
import './App.css'
import './index.css'

function App() {
  // return ENV.IS_WEB ? <WebAppShell /> : <TgAppShell />
  return <WebAppShell />
}

export default App
